import "./Nav.scss";

const Nav = () => {
  return (
    <ul className="nav">
      <li>
        <a href="#about"> ABOUT </a>
      </li>
      <li>
        <a href="#skills"> SKILLS </a>
      </li>
      <li>
        <a href="#projects"> PROJECTS </a>
      </li>
      <li>
        <a href="#contact"> CONTACT</a>
      </li>
    </ul>
  );
};
export default Nav;
